import script from "./ValiListMini.vue?vue&type=script&setup=true&lang=js"
export * from "./ValiListMini.vue?vue&type=script&setup=true&lang=js"

import "./ValiListMini.vue?vue&type=style&index=0&id=34b9bd68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34b9bd68"]])

export default __exports__